export const convertNestedArrayToArrayOfObjects = (data: any) => {
  let keys: any = data.shift(),
    i: number = 0,
    k: number = 0,
    obj: any = null,
    output: any[] = [];
  for (i = 0; i < data.length; i++) {
    obj = {};
    for (k = 0; k < keys.length; k++) {
      obj[keys[k]] = data[i][k];
    }
    output.push(obj);
  }
  return output;
};

export function debounce(func: any, wait: number, immediate: boolean) {
  let timeout: any;
  return function (this: any) {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export const convertSnapToPOJO = (snap: any): any => {
  if (snap) {
    return {
      ...snap.data(),
      key: snap.id,
    };
  } else {
    return null;
  }
};
